module.exports = __webpack_public_path__ + "img/c-end.fd4673a.png";